export const FONT_WEIGHTS = {
  thin: 300,
  base: 400,
  medium: 500,
  semiBold: 600,
  bold: 700,
} as const;

export const FONT_VARIANTS = {
  small: {
    fontSize: "12px !important",
    lineHeight: "14px !important",
  },
  base: {
    fontSize: "14px !important",
    lineHeight: "20px !important",
  },
  semiMedium: {
    fontSize: "16px !important",
    lineHeight: "24px !important",
  },
  medium: {
    fontSize: "20px !important",
    lineHeight: "28px !important",
  },
  large: {
    fontSize: "24px !important",
    lineHeight: "32px !important",
  },
  xlarge: {
    fontSize: "32px !important",
    lineHeight: "40px !important",
  },
  xxlarge: {
    fontSize: "40px !important",
    lineHeight: "48px !important",
  },
} as const;
